export default __webpack_public_path__ + "static/media/Paychex.82b3d17b.svg";